// SEO utility functions for dynamic meta tags and structured data

export const updateMetaTags = ({ title, description, keywords, image, url, type = 'website' }) => {
  // Update title
  document.title = title || 'MD Sweets Caterers - Traditional Indian Sweets Online';
  
  // Update or create meta tags
  const metaTags = {
    'description': description || 'Order delicious traditional Indian sweets online from MD Sweets Caterers. Fresh, quality sweets delivered to your doorstep. Custom orders for events available.',
    'keywords': keywords || 'indian sweets, traditional sweets, gulab jamun, rasgulla, jalebi, barfi, ladoo, kaju katli, sweets online, sweet shop, catering services',
    'author': 'MD Sweets Caterers',
    'robots': 'index, follow',
    
    // Open Graph tags
    'og:title': title || 'MD Sweets Caterers - Traditional Indian Sweets Online',
    'og:description': description || 'Order delicious traditional Indian sweets online from MD Sweets Caterers.',
    'og:image': image || 'https://mdsweets.shop/og-image.jpg',
    'og:url': url || 'https://mdsweets.shop',
    'og:type': type,
    'og:site_name': 'MD Sweets Caterers',
    'og:locale': 'en_US',
    
    // Twitter Card tags
    'twitter:card': 'summary_large_image',
    'twitter:title': title || 'MD Sweets Caterers - Traditional Indian Sweets Online',
    'twitter:description': description || 'Order delicious traditional Indian sweets online from MD Sweets Caterers.',
    'twitter:image': image || 'https://mdsweets.shop/og-image.jpg',
  };
  
  Object.entries(metaTags).forEach(([name, content]) => {
    let element = document.querySelector(`meta[name="${name}"]`) || 
                  document.querySelector(`meta[property="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      if (name.startsWith('og:') || name.startsWith('twitter:')) {
        element.setAttribute('property', name);
      } else {
        element.setAttribute('name', name);
      }
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  });
  
  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', url || window.location.href);
};

export const generateProductSchema = (product) => {
  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.name,
    "image": product.image,
    "description": product.description || product.longDescription,
    "brand": {
      "@type": "Brand",
      "name": "MD Sweets Caterers"
    },
    "offers": {
      "@type": "Offer",
      "url": `https://mdsweets.shop/product/${product.id}`,
      "priceCurrency": "INR",
      "price": product.price,
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "MD Sweets Caterers"
      }
    },
    "aggregateRating": product.rating ? {
      "@type": "AggregateRating",
      "ratingValue": product.rating,
      "reviewCount": product.reviewCount || 1
    } : undefined
  };
};

export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MD Sweets Caterers",
    "image": "https://mdsweets.shop/logo.png",
    "url": "https://mdsweets.shop",
    "telephone": "+91-XXXXXXXXXX",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Your Street Address",
      "addressLocality": "Your City",
      "addressRegion": "Your State",
      "postalCode": "XXXXXX",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 0.0,
      "longitude": 0.0
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "09:00",
      "closes": "21:00"
    },
    "sameAs": [
      "https://www.facebook.com/mdsweets",
      "https://www.instagram.com/mdsweets",
      "https://twitter.com/mdsweets"
    ]
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

export const injectStructuredData = (schema) => {
  // Remove existing structured data script if present
  const existingScript = document.querySelector('script[type="application/ld+json"]');
  if (existingScript) {
    existingScript.remove();
  }
  
  // Create and inject new structured data
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
};

export const generateSiteSearchSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://mdsweets.shop",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://mdsweets.shop/shop?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };
};
